/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Emailsentfrom_Label4Inputs */

const en_coinvestments_editemail_emailsentfrom_label4 = /** @type {(inputs: Coinvestments_Editemail_Emailsentfrom_Label4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Coinvestments_Editemail_Emailsentfrom_Label4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_emailsentfrom_label4 = /** @type {((inputs?: Coinvestments_Editemail_Emailsentfrom_Label4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Emailsentfrom_Label4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_emailsentfrom_label4(inputs)
});
export { coinvestments_editemail_emailsentfrom_label4 as "coInvestments_editEmail_emailSentFrom_label" }